import React, { useEffect, useRef } from "react";
import { Button } from "primereact/button";
import "./ButtonsSection.css";
import { useRBAC } from "../../hooks/RBACContext";
import { FN_SHIFT_KEY_MAPPING, WRITE_ACCESS_CTA, VALID_FUNCTION_KEYS } from "../../utils/Constants";
import { useModal } from "../../hooks/ModalContext";
import { confirmationModalObject } from "../Modal/ConfirmationModal.class";
import { dispatchBackBtnTriggeredEvent, isBackBtnKey } from "../../utils/UtilFunctions";

const dispatchBackBtnEventIfTriggered = (button) => {
  if (isBackBtnKey(button, "button_label")) {
    dispatchBackBtnTriggeredEvent();
  }
};

const isFunctionKey = (key) => VALID_FUNCTION_KEYS.includes(key);

const ButtonsSection = ({ ctaButtons, align = "" }) => {
  const handleKeyDownRef = useRef();
  const { writeAccess } = useRBAC();
  const { isModalVisible } = useModal();
  useEffect(() => {
    handleKeyDownRef.current = (event) => {
      let { key, shiftKey } = event;
      if (shiftKey) {
        key = FN_SHIFT_KEY_MAPPING[key];
      }
        const button = ctaButtons.find((b) => b.button_key && key && b.button_key === key);
      const { isConfirmationModalOpen } = confirmationModalObject;
      if (button && !isModalVisible  && !isConfirmationModalOpen) {
        console.log("in ting", button);
        event.preventDefault();
        dispatchBackBtnEventIfTriggered(button);
        button.button_handeler();
      }
    };

    const handleKeyDown = (event) => handleKeyDownRef.current(event);
    window?.self?.focus()
    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [ctaButtons]);

  return (
    <div className={`button-section-container ${align}`}>
      {ctaButtons.map((button, index) => {
        if (
          !writeAccess &&
          WRITE_ACCESS_CTA.some((option) =>
            button.button_label.toUpperCase().includes(option)
          )
        ) {
          return null;
        }

        return (
          <div className="button-container" key={button.button_label}>
            <Button
              id={button.button_label}
              label={button.button_label}
               onClick={() => {
                dispatchBackBtnEventIfTriggered(button);
                button.button_handeler();
              }}
              tooltip={
                isFunctionKey(button.button_key) ? button.button_key : ""
              } // Tooltip for function key only
              tooltipOptions={{ position: "top" }}
              key={button.button_label}
              severity="secondary"
            />
          </div>
        );
      })}
    </div>
  );
};

export default ButtonsSection;
